export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    transactionPlace = "",
    accountNumber = "",
    details = [],
    openingBalance = 0,
    totalReceiptAmount = 0,
    totalPaymentAmount = 0,
    closingBalance = 0,
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.recordingDate || ""}</td>
      <td class="border text-center">${item.docNumber || ""}</td>
      <td class="border text-center">${item.docDate || ""}</td>
      <td class="border px-1">${item.description || ""}</td>
      <td class="border text-center">${item.offsetAccount || ""}</td>
      <td class="border text-right px-1">${fmt(item.receiptAmount)}</td>
      <td class="border text-right px-1">${fmt(item.paymentAmount)}</td>
      <td class="border text-right px-1 font-bold bg-light">${fmt(item.balanceAmount)}</td>
      <td class="border px-1">${item.note || ""}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.5;">
      <table width="100%">
        <tr>
          <td width="40%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="60%" align="center">
            <div class="font-bold">Mẫu số S08-DN</div>
            <div style="font-style: italic; font-size: 12px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 25px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 18px;">SỔ TIỀN GỬI KHÔNG KỲ HẠN</h2>
        <div style="margin-top: 10px;">
          Nơi mở tài khoản giao dịch: <span class="dotted-line px-1">${transactionPlace}</span>
        </div>
        <div style="margin-top: 5px;">
          Số hiệu tài khoản tại nơi gửi: <span class="dotted-line px-1 font-bold">${accountNumber}</span>
        </div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="90">Ngày, tháng ghi sổ</th>
            <th class="border" colspan="2" width="160">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="80">Tài khoản đối ứng</th>
            <th class="border" colspan="3">Số tiền</th>
            <th class="border" rowspan="2" width="120">Ghi chú</th>
          </tr>
          <tr>
            <th class="border" width="80">Số hiệu</th>
            <th class="border" width="80">Ngày, tháng</th>
            <th class="border" width="110">Thu (gửi vào)</th>
            <th class="border" width="110">Chi (rút ra)</th>
            <th class="border" width="110">Còn lại</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">F</th>
          </tr>
        </thead>
        <tbody>
          <!-- DÒNG SỐ DƯ ĐẦU KỲ -->
          <tr style="font-weight: bold;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số dư đầu kỳ</td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border text-right px-1 font-bold">${fmt(openingBalance)}</td>
            <td class="border"></td>
          </tr>
          
          <tr style="font-style: italic;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số phát sinh trong kỳ</td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
          </tr>

          ${tableRows}
          
          <!-- DÒNG CỘNG SỐ PHÁT SINH TRONG KỲ -->
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Cộng số phát sinh trong kỳ</td>
            <td class="border text-center">X</td>
            <td class="border text-right px-1">${fmt(totalReceiptAmount)}</td>
            <td class="border text-right px-1">${fmt(totalPaymentAmount)}</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
          </tr>
          
          <!-- DÒNG SỐ DƯ CUỐI KỲ -->
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số dư cuối kỳ</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
            <td class="border text-right px-1 font-bold">${fmt(closingBalance)}</td>
            <td class="border text-center">X</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 12px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 6px; }
        .bg-light { background-color: #fdfdfd; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; }
      </style>
    </div>
  `;
};
